import type { Link } from "@idme/link";
import type { Icon } from "@idme/icon";
export function initPage() {
  document.body.addEventListener("click", (e) => {
    const target = e.target as Link;
    const isSeeMoreLink = target.matches(".see-more");
    const isSeeMoreIcon = target.parentElement?.matches(".see-more");
    if (isSeeMoreLink || isSeeMoreIcon) {
      const link = isSeeMoreIcon ? (target.parentElement! as Link) : target;
      const parent = link.parentElement as HTMLDivElement;
      const isExpanded = parent.classList.toggle("expanded");
      const data = link.dataset;
      link.text = (
        isExpanded ? data.labelExpanded : data.labelCollapsed
      ) as string;
      for (const icon of link.querySelectorAll<Icon>("idme-icon")) {
        icon.name = isExpanded ? "chevron-up" : "chevron-down";
      }
    }
  });
}
